import { CreditLabelKey } from '@rhg/components/media/audio-player/credits';

/**
 * Maps player credit label keys to page wording.
 * The page keeps "Clinical Author" where the player uses the generic "Author".
 * All other keys pass through unchanged.
 */
export const pageCreditLabelKey = (
    k: CreditLabelKey
): CreditLabelKey | 'common.clinical_author' =>
    k === 'common.author' ? 'common.clinical_author' : k;
